<template>
<div>
    <main-header v-show="showHeader"/>
    <router-view />
    <main-footer v-show="showFooter"/>
</div>
</template>

<script>
import MainHeader from './components/include/MainHeader.vue'
import MainFooter from './components/include/MainFooter.vue'
import MainAside from './components/include/MainAside.vue'
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      showHeader: true,
      showFooter: true
    }
  },
  components: {
    'main-header': MainHeader,
    'main-footer': MainFooter,
    'main-aside': MainAside
  },
  created () {
    axios
      .get('/web/api/member/checkauth')
      .then(resp => {
        this.login(resp.data)
      })
  },
  methods: {
    ...mapActions([ 'login' ])
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue